import { IRouteMetadata } from "@faire/web-api/Route";
import { props as openWithFaireRouteProps } from "@faire/web-api/routes/open-with-faire";
import { props as openWithFaireAcademyProps } from "@faire/web-api/routes/open-with-faire/academy";
import { props as openWithFaireAcademyBuyRetailInventoryProps } from "@faire/web-api/routes/open-with-faire/academy/buy-retail-inventory";
import { props as openWithFaireAcademyFindRetailSpaceProps } from "@faire/web-api/routes/open-with-faire/academy/find-retail-space";
import { props as openWithFaireAcademyGetFundingAndLicensesProps } from "@faire/web-api/routes/open-with-faire/academy/funding-licensing";
import { props as openWithFaireAcademyLayTheGroundworkProps } from "@faire/web-api/routes/open-with-faire/academy/lay-the-groundwork";
import { props as openWithFaireAcademyOrganizeStoreOperationsProps } from "@faire/web-api/routes/open-with-faire/academy/organize-store-operations";
import { props as openWithFaireAcademyPromoteYourStoreProps } from "@faire/web-api/routes/open-with-faire/academy/promote-your-store";
import { props as openWithFaireAcademyRenovateYourStoreProps } from "@faire/web-api/routes/open-with-faire/academy/renovate-your-store";
import { Route } from "@faire/web/ui/routing/Route";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";

import { LazyFindRetailSpace } from "@faire/retailer/views/open-with-faire/academy/find-retail-space/LazyFindRetailSpace";
import { LazyGetFundingAndLicenses } from "@faire/retailer/views/open-with-faire/academy/get-funding-and-licenses/LazyGetFundingAndLicenses";
import { LazyOpenWithFaireFaireAcademyGuideLandingPage } from "@faire/retailer/views/open-with-faire/academy/guideLandingPage/LazyOpenWithFaireFaireAcademyLandingPage";
import { LazyPlanAndBuyInventory } from "@faire/retailer/views/open-with-faire/academy/plan-and-buy-inventory/LazyPlanAndBuyInventory";
import { LazyRenovateYourStore } from "@faire/retailer/views/open-with-faire/academy/renovate-your-store/LazyRenovateYourStore";

import { LazyLayTheGroundwork } from "./academy/lay-the-groundwork/LazyLayTheGroundwork";
import { LazyOrganizeStoreOperations } from "./academy/organize-store-operations/LazyOrganizeStoreOperations";
import { LazyPromoteYourStore } from "./academy/promote-your-store/LazyPromoteYourStore";
import { LazyOpenWithFaireFaireAcademyLandingPage } from "./OpenWithFaireFaireAcademyLandingPage/LazyOpenWithFaireFaireAcademyLandingPage";

const ACADEMY_GUIDE_ROUTES: Array<{
  routeProps: IRouteMetadata & { path: string };
  component: React.ComponentType;
}> = [
  {
    routeProps: openWithFaireAcademyLayTheGroundworkProps,
    component: LazyLayTheGroundwork,
  },
  {
    routeProps: openWithFaireAcademyGetFundingAndLicensesProps,
    component: LazyGetFundingAndLicenses,
  },
  {
    routeProps: openWithFaireAcademyFindRetailSpaceProps,
    component: LazyFindRetailSpace,
  },
  {
    routeProps: openWithFaireAcademyRenovateYourStoreProps,
    component: LazyRenovateYourStore,
  },
  {
    routeProps: openWithFaireAcademyBuyRetailInventoryProps,
    component: LazyPlanAndBuyInventory,
  },
  {
    routeProps: openWithFaireAcademyOrganizeStoreOperationsProps,
    component: LazyOrganizeStoreOperations,
  },
  {
    routeProps: openWithFaireAcademyPromoteYourStoreProps,
    component: LazyPromoteYourStore,
  },
];

export const OpenWithFaireRouter: React.FC = () => {
  return (
    <Switch>
      <Route
        {...openWithFaireAcademyProps}
        exact
        component={LazyOpenWithFaireFaireAcademyGuideLandingPage}
      />
      {ACADEMY_GUIDE_ROUTES.map(({ routeProps, component }) => (
        <Route
          {...routeProps}
          exact
          key={routeProps.path}
          component={component}
        />
      ))}
      <Route
        {...openWithFaireRouteProps}
        component={LazyOpenWithFaireFaireAcademyLandingPage}
      />
    </Switch>
  );
};
